module.exports = __webpack_public_path__ + "static/about-content-image-5@2x-74e138c06cb9bd41623b0821e91b6653.jpg";